import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initGlobalAnimations = () => {
    

    // 1. Page Load Animation (Main Content Wrapper)
    const main = document.querySelector('main');
    if (main) {
       gsap.fromTo(main, 
           { autoAlpha: 0 },
           { autoAlpha: 1, duration: 1.2, ease: 'power2.out' } 
       );
    }

    // 2. Elements Scroll Animation (Text, Images, Buttons)
    // Exclude elements inside swiper to avoid conflicts
    const elementsSelectors = [
        'main p',
        'main h1', 'main h2', 'main h3', 'main h4', 'main h5', 'main h6',
        'main img:not(.swiper-slide img):not(.splide__slide img):not(.no-global-animate)',
        'main .btn', 
        'main li', // List items often contain text
        
        // Custom Text Classes (About Page)
        '.about-us-title',
        '.label-frame-outer',
        '.description-text',
        
        // Custom Text Classes (Project Detail)
        '.section-intro-image .location',
        '.section-intro-image .title',
        '.section-intro-image .description',
        '.section-left-image-right-text .text-content',
        '.section-left-image-right-text .quote',
        //'.project-footer .text',
        
         // Accordion Text (if not handled by specific accordion animation)
         '.accordion-header .accordion-title',
         '.accordion-content' 
    ];
    
    const elementsString = elementsSelectors.join(', ');
    const elements = document.querySelectorAll(elementsString);

    // Debug: Check if elements are found
    // console.log(`GSAP: Found ${elements.length} elements to animate.`);

    elements.forEach((el) => {
        // Double check for swiper parent
        if (el.closest('.swiper')) return;
        if (el.closest('.splide')) return;
        if (el.closest('.accordion')) return; // Handle accordions separately

        // Ensure element starts hidden to avoid FOUC (Flash of Unstyled Content) if possible
        // but since we are client-side, we use fromTo to force the state immediately.
        
        gsap.fromTo(el, 
            { autoAlpha: 0 }, 
            {
                autoAlpha: 1,
                duration: 2.0, // Slower for elegance
                ease: 'power3.out', // Smoother ease
                scrollTrigger: {
                    trigger: el,
                    start: 'top 95%', // Trigger slightly earlier (when top of element hits 95% of viewport height)
                    toggleActions: 'play none none reverse',
                    // markers: true // Uncomment for debugging
                }
            }
        );
    });


    // 3. Accordion Animation (Staggered)
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll('.accordion-item');
        if (items.length > 0) {
            gsap.fromTo(items, 
                { autoAlpha: 0 },
                {
                    autoAlpha: 1,
                    duration: 1.2,
                    stagger: 0.1,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: accordion,
                        start: 'top 85%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        }
    });
};

// Auto-init
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalAnimations);
} else {
    initGlobalAnimations();
}
